import React, { useEffect } from 'react'
import './scss/-scss.scss'
import logo from '../../assets/img/logo2.png'
import wpp from '../../assets/img/wpp.png'
import imo from '../../assets/img/imo2.png'
import pna from '../../assets/img/pna2.png'
import cassensPlath from '../../assets/img/cassensPlath.png'
import simple from '../../assets/img/keppSimple.jpeg'
import paperless from '../../assets/img/goPaperless.jpeg'

import ControlledCarousel from './Carousel'
import { Footer } from './Footer.jsx'
import { ContactForm } from './ContactForm.jsx'
import aboutImg from '../../assets/img/aboutPhoto.jpg'
import { BsArrowDownShort, BsCheckLg } from 'react-icons/bs'
import { FaCrown, FaPhoneAlt, FaWrench, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa'
import { ProtectedLink, CONTACTS } from '../../Components/ProtectedContact/ProtectedContact.jsx'

import AOS from 'aos';
import 'aos/dist/aos.css';

import {
    GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';

export const Home = () => {

    const alertEffect = () => {
        let alerta = document.getElementById("alert");
        alerta.classList.remove("hidden");
        alerta.classList.add("showAlert");
        setTimeout(() => {
            alerta.classList.add("hideAlert");
            setTimeout(() => {
                alerta.classList.add("hidden");
                alerta.classList.remove("showAlert");
                alerta.classList.remove("hideAlert");
            }, 1200);
        }, 3000);
    }

    const alertClose = () => {
        let alerta = document.getElementById("alert");
        alerta.classList.add("hide");
        setTimeout(() => {
            alerta.classList.add("hidden");
            alerta.classList.remove("showAlert");
            alerta.classList.remove("hideAlert");
        }, 1200);
    }

    useEffect(() => {
        AOS.init();
    }, [])

    useEffect(() => {
        const counters = document.querySelectorAll('.contadores .cont');

        const animateCounter = (numberEl) => {
            const target = parseInt(numberEl.getAttribute('data-cantidad-total'), 10) || 0;
            const duration = 2000;
            const startTime = performance.now();

            const step = (now) => {
                const progress = Math.min((now - startTime) / duration, 1);
                numberEl.textContent = Math.floor(progress * target).toLocaleString('en-US');
                if (progress < 1) {
                    requestAnimationFrame(step);
                } else {
                    numberEl.textContent = target.toLocaleString('en-US');
                }
            };
            requestAnimationFrame(step);
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.remove('ocultar');
                    entry.target.classList.add('animar');
                    animateCounter(entry.target.querySelector('.number'));
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        counters.forEach((cont) => observer.observe(cont));

        return () => observer.disconnect();
    }, [])

    return (
        <>
            {/* <!-- Header --> */}
            <header id="header">
                {/* <!-- Logo --> */}
                <div className="grid-header">
                    <div onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}>
                        <h1 className="img-fluid">Instrumental Dufour</h1>
                        <img src={logo} alt="Instrumental Dufour" />
                    </div>
                    {/* <!-- Nav --> */}
                    <nav>
                        <ul>
                            <li className="li"> <a href="#about-us">About us</a></li>
                            <li className="li"> <a href="#services">Services</a></li>
                            <li className="li"> <a href="#contact">Contact</a></li>
                        </ul>
                        <div className="li">
                            <p className="mediaA" onClick={e => alertEffect(e)}> Our platform</p>
                            <p className="mediaA"><i className="fa-solid fa-right-to-bracket" onClick={e => alertEffect(e)}></i></p>

                        </div>
                    </nav>

                    {/* <!-- Sign In --> */}

                    <div className="platformCont">
                        <div className="platform">
                            <p className="mediaB" onClick={e => alertEffect(e)}> Our platform</p>
                            <p className="mediaB"><i className="fa-solid fa-right-to-bracket" onClick={e => alertEffect(e)}></i></p>
                        </div>
                    </div>
                </div>
            </header>

            <main>

                <section id="intro">
                    <ControlledCarousel alertEffect={alertEffect} />
                </section>
                {/* <!-- Platform Alert --> */}

                <div className="hidden" id="alert">
                    <i className="fa-solid fa-circle-info"></i>
                    <span className="msg">Coming soon! We are working for you.</span>
                    <span className="close-btn" onClick={alertClose}><i className="fa fa-xmark"></i></span>
                </div>

                {/* <!-- WhatsApp Logo --> */}

                <ProtectedLink value={CONTACTS.technical1} type="whatsapp" target="_blank" rel="noreferrer">
                    <img src={wpp} id="wpp" alt="Whatsapp" />
                </ProtectedLink>

                {/* <!-- About us --> */}
                <section id="about-us" >
                    <article className="row col-12 justify-content-center" data-aos="fade-up" data-aos-duration="600">
                        <h2 className="main-title col-12">About us</h2>
                        <div className="aboutIntro" data-aos="fade-up" data-aos-duration="600">
                            <div className="aboutImg">
                                <div className="aboutImgFrame">
                                    <img src={aboutImg} alt="Magnetic compass on a ship's deck" />
                                </div>
                                <div className="aboutBadge">
                                    <span>Since</span>
                                    <span className="aboutBadgeYear">1939</span>
                                </div>
                            </div>
                            <div className="aboutText">
                                <span className="aboutEyebrow">Who we are</span>
                                <h3 className="aboutTitle">Repairing and calibrating magnetic compasses for over 85 years.</h3>
                                <p>The only authorized laboratory in Argentina issuing certificates with all international and legal validations, accepted worldwide by any class inspection or Coast Guard authority.</p>
                                <ul className="aboutChecks">
                                    <li><span className="aboutCheck"><BsCheckLg /></span>Authorized by PNA, IMO member state</li>
                                    <li><span className="aboutCheck"><BsCheckLg /></span>First fully remote compass calibration service</li>
                                    <li><span className="aboutCheck"><BsCheckLg /></span>Magnetic compass calibration and certificates in less than 24h</li>
                                </ul>
                            </div>
                        </div>

                        <div className="contadores">
                            <div className="cont ocultar">
                                <div className="number" data-cantidad-total="5000">0</div>
                                <p>Issued certificates</p>
                            </div>
                            <div className="cont ocultar">
                                <div className="number" data-cantidad-total="3000">0</div>
                                <p>Repaired compasses</p>
                            </div>
                            <div className="cont ocultar">
                                <div className="number" data-cantidad-total="5000">0</div>
                                <p>Completed services</p>
                            </div>
                        </div>

                        {/* <!-- Logos: authorities + partner --> */}
                        <div className="aboutLogos" data-aos="fade-up" data-aos-duration="600">
                            <img src={pna} alt="Logo Prefectura Naval Argentina" />
                            <img src={imo} alt="Logo IMO International Maritime Organization" />
                            <div className="aboutLogosDivider"></div>
                            <div className="aboutPartner">
                                <img src={cassensPlath} alt="Logo Cassens & Plath nautical equipment" />
                                <span className="partner-label">Official service and distributor</span>
                            </div>
                        </div>

                    </article>
                </section>

                {/* Whats new - temporarily disabled
                <section id="new" className="bg-dark" >
                    <div data-aos="fade-up" data-aos-duration="600">
                        <h2 className="main-title col-12 text-light">What is new</h2>
                        <article className="row col-12 justify-content-center">
                            <div className="flex-row col-11 py-5 my-5 justify-content-center newInfo" data-aos="fade-left" data-aos-duration="600" data-aos-delay="100">
                                <div className="col-xl-7 col-lg-10 col-12 p-0 new-p ">
                                    <h3 className="new-subtitle m-0">Keep it simple.</h3>
                                    <p className="text-light">As a complement to the remote calibration service, we have developed an online platform where each ship upload its magnetic compass information making the workflow faster, easier and even more organized. Furthermore, the ship will count with 24/7 assistance if needed. One month before the expiration date the ship will receive a notification in order to renew all magnetic compass certificates.</p>
                                </div>
                                <img className="img-fluid" src={simple} alt="Online platform" />
                            </div>
                            <div className="flex-row-reverse col-11 py-5 my-5 justify-content-center newInfo" data-aos="fade-right" data-aos-delay="100" data-aos-duration="600">
                                <div className="col-xl-7 col-lg-10 col-12 p-0 new-p">
                                    <h3 className="new-subtitle m-0">Go Paperless.</h3>
                                    <p className="text-light">In order to contribute with climate change as well as we increase the security of our work we have replaced the old and traditional hand-drown sign for the digital one. This method speed up the process and count with all legal validations.</p>
                                </div>
                                <img className="img-fluid" src={paperless} alt="Digital sign" />
                            </div>
                        </article>
                    </div>
                </section>
                */}

                {/* <!-- Services --> */}

                <section id="services">
                    <article data-aos="fade-up" data-aos-duration="600">
                        <h2 className="services-title col-12">Services</h2>
                        <div className="servicesWrap">

                            {/* Featured: Remote Calibration */}
                            <div className="featuredService">
                                <span className="featuredBadge"><FaCrown /></span>
                                <div className="featuredMain">
                                    <div className="featuredText">
                                        <span className="featuredEyebrow">Our flagship service</span>
                                        <h3 className="featuredTitle">Remote Calibration</h3>
                                        <p className="featuredSubtitle">Calibrate your magnetic compass while navigating anywhere in the world. No technician on board, no docking.</p>
                                        <ol className="featuredSteps">
                                            <li><span className="stepNumber">1</span><span><b>Share the data.</b> The captain uploads the compass information to our online platform.</span></li>
                                            <li><span className="stepNumber">2</span><span><b>Get instructions.</b> Easy, detailed steps to adjust the deviations.</span></li>
                                            <li><span className="stepNumber">3</span><span><b>Adjust with support.</b> A technician is available 24/7 for any inquiry.</span></li>
                                            <li><span className="stepNumber">4</span><span><b>Receive certificates.</b> New deviation sheet and certificates by email.</span></li>
                                        </ol>
                                        <a href="#contact" className="quoteBtn">Get a quote</a>
                                    </div>
                                    <figure className="featuredImg">
                                        <img src={simple} alt="Online platform" />
                                        <figcaption>All compass information in one place, on our online platform.</figcaption>
                                    </figure>
                                </div>
                                <div className="featuredAdvantages">
                                    <div>
                                        <h4>Advantages for the ship</h4>
                                        <ul>
                                            <li>Adjust while navigating, without docking or delaying the shipment</li>
                                            <li>A technician available 24/7</li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h4>Advantages for owners and managers</h4>
                                        <ul>
                                            <li>No embarkation or disembarkation costs for the technician</li>
                                            <li>Fixed budget, no extra cost by day or hour; cheaper in volume</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Other services: pure-CSS accordion */}
                            <ul id="accordion">
                                <li>
                                    <h3 className="serviceCardTitle">On-board calibration</h3>
                                    <p className="servicesSubtitle">A technician on board manually calibrates the magnetic compass and issues the certificates, digitally signed by technician and captain.</p>
                                    <input type="checkbox" name="accordion" id="secondAccordion" />
                                    <label htmlFor="secondAccordion">How it works <BsArrowDownShort /></label>
                                    <div className="contentAccordion">
                                        <ul>
                                            <li>The technician will tell the captain to perform certain maneuvers in order to check and adjust the magnetic compass as necessary.</li>
                                            <li>Once all deviations were adjusted, the technician will issue on board the certificates with all legal and international validations. Both will be digitally signed by the technician and the captain.</li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <h3 className="serviceCardTitle">Magnetic compass reparation</h3>
                                    <p className="servicesSubtitle">Ship or bring your compass to our laboratory. Repaired in less than 24 hours, with an overhaul certificate and a 1-year warranty.</p>
                                    <input type="checkbox" name="accordion" id="thirdAccordion" />
                                    <label htmlFor="thirdAccordion">How it works <BsArrowDownShort /></label>
                                    <div className="contentAccordion">
                                        <ul>
                                            <li>Get the magnetic compass inspected in order to identify the problem.</li>
                                            <li>One of our technicians will have it repaired in less than 24 hours.</li>
                                            <li>Once repaired, our technician will issue the compass overhaul certificate counting with a year of warranty included.</li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </article>
                </section>

                {/* <!-- Contact --> */}

                <section id="contact" data-aos="fade-up" data-aos-duration="600">
                    <h2 className="main-title">Contact</h2>
                    <p className="contactIntro">Need a quote or have a question? Our technicians will get back to you.</p>

                    <div className="contactCard">
                        {/* <!-- Inquires --> */}
                        <div className="contactInfo">
                            <div className="contactInfoHeader">
                                <h3>Get in touch</h3>
                                <p>Call, write or message us. We answer from anywhere in the world.</p>
                            </div>

                            <div className="contactItem">
                                <span className="contactIcon"><FaPhoneAlt /></span>
                                <div>
                                    <span className="contactLabel">US / International</span>
                                    <ProtectedLink value={CONTACTS.international} placeholder="+1 (···) ···-····" />
                                </div>
                            </div>

                            <div className="contactItem">
                                <span className="contactIcon"><FaWrench /></span>
                                <div>
                                    <span className="contactLabel">Technical department</span>
                                    <ProtectedLink value={CONTACTS.technical1} placeholder="+54 9 11 ···· ····" />
                                    <ProtectedLink value={CONTACTS.technical2} placeholder="+54 9 11 ···· ····" />
                                </div>
                            </div>

                            <div className="contactItem">
                                <span className="contactIcon"><FaEnvelope /></span>
                                <div>
                                    <span className="contactLabel">Email</span>
                                    <ProtectedLink value={CONTACTS.email} type="mailto" placeholder="Show email" target="_blank" rel="noreferrer" />
                                </div>
                            </div>

                            <div className="contactItem">
                                <span className="contactIcon"><FaMapMarkerAlt /></span>
                                <div>
                                    <span className="contactLabel">Laboratory</span>
                                    <span className="contactAddress">Don Orione 651, Victoria, Buenos Aires</span>
                                    <a className="contactMaps" href="https://www.google.com.ar/maps/place/Don+Orione+651,+B1644BMK+Victoria,+Provincia+de+Buenos+Aires/@-34.4498501,-58.5329738,17z/data=!3m1!4b1!4m6!3m5!1s0x95bcafc2bb2d4b9b:0x498bd94a94c1372!8m2!3d-34.4498501!4d-58.5307851!16s%2Fg%2F11mtscl02t" target="_blank" rel="noreferrer">Open in Maps</a>
                                </div>
                            </div>

                            <ProtectedLink value={CONTACTS.technical1} type="whatsapp" className="contactWhatsapp" target="_blank" rel="noreferrer">
                                <FaWhatsapp /> Chat on WhatsApp
                            </ProtectedLink>
                        </div>

                        {/* <!-- Form --> */}
                        <GoogleReCaptchaProvider reCaptchaKey="6LeJMUsnAAAAAIRowguL2UeHjTPw8X2vZWSXBQAC">
                            <ContactForm />
                        </GoogleReCaptchaProvider>
                    </div>
                </section>

                {/* <!-- Footer --> */}
                <Footer />

            </main>
        </>
    )
}
